import React from 'react';

import { messagesModel } from '@/features';

import { ColorOptions } from './ColorOptions';
import { TextOptions } from './TextOptions';
import { MessageOptions } from './MessageOptions';

export const MessageFields: React.FC<{
  messageId: string;
  visitorOptionsFields: messagesModel.VisitorOptionsField[];
  options?: string[];
}> = ({ messageId, visitorOptionsFields, options }) => (
  <>
    {visitorOptionsFields.map((field) => {
      switch (field.type) {
        case messagesModel.VisitorOptionsFieldTypes.Selection:
          return <TextOptions messageId={messageId} options={field.choices} />;
        case messagesModel.VisitorOptionsFieldTypes.Color:
          return <ColorOptions messageId={messageId} choices={field.choices} />;
        default:
          return options && options.length > 0 ? (
            <MessageOptions messageId={messageId} options={options} />
          ) : null;
      }
    })}
  </>
);
